// import ComponentName from 'package-name/<directory>/<file-name>'
// In the demo package name is @jibin/common, and file is directly inside the package
import HeaderChecklist from 'components/ReusableComponents/HeaderChecklist'
import HotelPurchasedPlan from 'components/ReusableComponents/HotelPurchasedPlan'
import NotificationBell from 'components/ReusableComponents/NotificationBell'
import { useInternalAdmin } from 'hooks'
import { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  selectCurrency,
  selectIsInternalAdmin,
  selectLocale,
  selectPmsNeedsSync
} from '../accessors'
import {
  turnOffDemoMode,
  turnOffInternalAdmin,
  turnOnDemoMode,
  turnOnInternalAdmin
} from '../actions/index'
import { getCurrencyText } from '../utils/helpers'
import PmsPopup from './PmsPopup/index'
import HotelLocalTime from './ReusableComponents/HotelLocalTime/index'
import Toggle from './ReusableComponents/Toggle/index'
import { HeaderContext } from './Utils/HeaderContentProvider'

const CustomContent = () => {
  const { value } = useContext(HeaderContext)
  return value || null
}

const Header = ({ handleOpenNotificationCenter }) => {
  const currentPmsNeedSync = useSelector(selectPmsNeedsSync)
  const actuallyIsInternalAdmin = useSelector(s => s.login.actuallyIsInternalAdmin)
  const isInternalAdmin = useInternalAdmin()
  const title = useSelector(s => s.header.title)
  const subtitle = useSelector(s => s.header.subtitle)
  const width = useSelector(s => s.header.width)
  const isFixed = useSelector(s => s.header.isFixed)
  const currency = useSelector(selectCurrency)
  const locale = useSelector(selectLocale)
  return (
    <>
      <header className={isFixed ? 'header-fixed' : ''}>
        <div className="header-inner" style={{ width: width || '100%' }}>
          <div className="header-left">
            {title && <h1>{title}</h1>}
            {subtitle && <p>{subtitle}</p>}
          </div>
          <CustomContent />
          {/* <SwitchToDirectfulBar /> */}

          <div className="header-right">
            <HotelPurchasedPlan />
            <InternalAdminToggle />
            <span className="header-currency">
              <span>{getCurrencyText(currency, locale)}</span>
              {actuallyIsInternalAdmin && (
                <span className="header-localTime">
                  <HotelLocalTime />
                </span>
              )}
            </span>
            {actuallyIsInternalAdmin && <HeaderChecklist />}
            {currentPmsNeedSync && <PmsPopup />}
            {isInternalAdmin && (
              <button onClick={handleOpenNotificationCenter}>
                <div>
                  <NotificationBell />
                </div>
              </button>
            )}
          </div>
        </div>
      </header>
    </>
  )
}

const InternalAdminToggle = () => {
  const actuallyIsInternalAdmin = useSelector(s => s.login.actuallyIsInternalAdmin)
  const isDemoMode = useSelector(s => s.login.isDemoMode)
  const isInternalAdmin = useSelector(selectIsInternalAdmin)
  const dispatch = useDispatch()

  if (actuallyIsInternalAdmin) {
    return (
      <>
        <Toggle
          className="header-client-mode-toggle"
          isGray={true}
          checked={isDemoMode}
          label="Demo mode"
          handleChange={() => dispatch(isDemoMode ? turnOffDemoMode() : turnOnDemoMode())}
        />
        <Toggle
          className="header-client-mode-toggle"
          isGray={true}
          checked={!isInternalAdmin}
          label="View as client"
          handleChange={() =>
            dispatch(isInternalAdmin ? turnOffInternalAdmin() : turnOnInternalAdmin())
          }
        />
      </>
    )
  } else {
    return null
  }
}

export default Header
